import { useState, useEffect, useRef, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { Grid } from '@mui/material'
import { Link, Typography } from '@carto/meridian-ds/components'

import { useAppSelector, useAppDispatch } from 'app/state'
import { setMyAppsListFilter } from 'features/apps/state/appsSlice'
import FilterInput, { FilterInputRefProps } from 'features/common/ui/Forms/FilterInput/FilterInput'

function AccountAppsFilter() {
  const dispatch = useAppDispatch()
  const filterInputRef = useRef<FilterInputRefProps>(null)
  const myAppsListFilter = useAppSelector((state) => state.apps.myAppsListFilter)
  const filteredApps = useAppSelector((state) => state.apps.filteredApps)
  const [searchParam, setSearchParam] = useState(myAppsListFilter.searchBy || '')
  const [sortParam, setSortParam] = useState(myAppsListFilter.orderBy.fieldName)

  useEffect(() => {
    dispatch(
      setMyAppsListFilter({
        searchBy: searchParam,
        orderBy: {
          fieldName: sortParam,
          ascending: sortParam === 'updated_at' ? false : true
        }
      })
    )
  }, [searchParam, sortParam, dispatch])

  const clear = useCallback(() => {
    if (!filterInputRef.current) {
      return
    }

    setSortParam('title')
    filterInputRef.current.clear()
  }, [filterInputRef, setSortParam])

  return (
    <Grid container>
      <Grid item xs={12}>
        <FilterInput
          ref={filterInputRef}
          fullWidth={true}
          placeholderId="apps.gallery.searchPlaceholder"
          onChange={setSearchParam}
        />
      </Grid>
      {searchParam && (
        <Grid marginTop={2} display="flex" item xs={12} gap={1}>
          <Typography variant="caption" color="textPrimary">
            <FormattedMessage
              id="apps.gallery.searchResults"
              values={{
                number: filteredApps.length,
                param: searchParam
              }}
            />
          </Typography>
          <Link variant="caption" component="button" onClick={clear}>
            <FormattedMessage id="common.button.clear" />
          </Link>
        </Grid>
      )}
    </Grid>
  )
}

export default AccountAppsFilter
